/**
 * NOTE: this is an autogenerated file! do not change!
 * to change feature imports, edit /apps/<name>/shared/features.json!
 */

import {CoreBaseFeature} from "@common/core/feature";
import {MessagesBaseFeature} from "@common/messages/feature";
import {DocumentationBaseFeature} from "@common/documentation/feature";
import {MailBaseFeature} from "@common/mail/feature";
import {ConsoleBaseFeature} from "@common/console/feature";
import {AbilitiesBaseFeature} from "@common/abilities/feature";
import {MediaBaseFeature} from "@common/media/feature";
import {CloudinaryBaseFeature} from "@common/cloudinary/feature";
import {FaqBaseFeature} from "@common/faq/feature";
import {MaintenanceBaseFeature} from "@common/maintenance/feature";
import {NotificationsBaseFeature} from "@common/notifications/feature";
import {StatisticsBaseFeature} from "@common/statistics/feature";
import {CmsBaseFeature} from "@common/cms/feature";
import {FeedbackBaseFeature} from "@common/feedback/feature";
import {MailerBaseFeature} from "@common/mailer/feature";
import {UsersBaseFeature} from "@common/users/feature";
import {AccessibilityBaseFeature} from "@common/accessibility/feature";
import {AuthStrategyCredentialsBaseFeature} from "@common/auth-strategy-credentials/feature";
import {TrackingBaseFeature} from "@common/tracking/feature";
import {TaskSchedulerBaseFeature} from "@common/task-scheduler/feature";
import {UsersPasswordResetQrcodeBaseFeature} from "@common/users-password-reset-qrcode/feature";
import {MembershipBaseFeature} from "@common/membership/feature";
import {PaymentReminderBaseFeature} from "@common/payment-reminder/feature";
import {MpfMembershipPluginPaymentBaseFeature} from "@mpf/membership-plugin-payment/feature";
import {MpfContactBaseFeature} from "@mpf/contact/feature";
import {MpfUsersBaseFeature} from "@mpf/users/feature";
import {MpfCoursesBaseFeature} from "@mpf/courses/feature";
import {MpfDocentsBaseFeature} from "@mpf/docents/feature";
import {MpfAppBaseFeature} from "@mpf/app/feature";
import {MpfOptinUnlockVideoJumpingBaseFeature} from "@mpf/optin-unlock-video-jumping/feature";
import {CoreFrontendSharedFeature} from "@common/core/frontend-shared";
import {MessagesFrontendFeature} from "@common/messages/frontend";
import {DocumentationFrontendAdminFeature} from "@common/documentation/frontend-admin";
import {ConsoleFrontendSharedFeature} from "@common/console/frontend-shared";
import {AbilitiesFrontendAdminFeature} from "@common/abilities/frontend-admin";
import {MediaFrontendAdminFeature} from "@common/media/frontend-admin";
import {CloudinaryFrontendAdminFeature} from "@common/cloudinary/frontend-admin";
import {FaqFrontendAdminFeature} from "@common/faq/frontend-admin";
import {MaintenanceFrontendAdminFeature} from "@common/maintenance/frontend-admin";
import {NotificationsFrontendAdminFeature} from "@common/notifications/frontend-admin";
import {StatisticsFrontendAdminFeature} from "@common/statistics/frontend-admin";
import {CmsFrontendAdminFeature} from "@common/cms/frontend-admin";
import {FeedbackAdminFeature} from "@common/feedback/frontend-admin";
import {MailerFrontendAdminFeature} from "@common/mailer/frontend-admin";
import {UsersAdminFeature} from "@common/users/frontend-admin";
import {AccessibilityFrontendFeature} from "@common/accessibility/frontend";
import {AuthStrategyCredentialsFrontendFeature} from "@common/auth-strategy-credentials/frontend";
import {AuthStrategyCredentialsFrontendAdminFeature} from "@common/auth-strategy-credentials/frontend-admin";
import {TrackingFrontendAdminFeature} from "@common/tracking/frontend-admin";
import {TaskSchedulerFrontendAdminFeature} from "@common/task-scheduler/frontend-admin";
import {MembershipFrontendAdminFeature} from "@common/membership/frontend-admin";
import {PaymentReminderFrontendAdminFeature} from "@common/payment-reminder/frontend-admin";
import {MpfContactFrontendAdminFeature} from "@mpf/contact/frontend-admin";
import {MpfUsersFrontendAdminFeature} from "@mpf/users/frontend-admin";
import {MpfCoursesAdminFeature} from "@mpf/courses/frontend-admin";
import {MpfDocentsFrontendAdminFeature} from "@mpf/docents/frontend-admin";
import {MpfAppFrontendAdminFeature} from "@mpf/app/frontend-admin";
import {clientCacheDevToolProvider} from "@common/core/frontend-shared";
import {DevToolProviderToken} from "@core/shared/dev-tools";
import {modelMetadataDevToolDefinition} from "@common/core/frontend-shared";
import {storeInspectorDevToolDefinition} from "@common/core/frontend-shared";
import {MediaAssetProviderCloudinaryFrontend} from "@common/cloudinary/frontend-shared";
import {MEDIA_ASSET_PROVIDER_TOKEN} from "@common/media/shared";
import {AccessUserPluginFrontend} from "@common/users/frontend-shared";
import {ACCESS_SERVICE_PLUGIN_TOKEN} from "@core/shared/access";
import {MpfPaymentFrontendMembershipPlugin} from "@mpf/membership-plugin-payment/frontend-shared";
import {MEMBERSHIP_PLUGINS_TOKEN} from "@common/membership/shared";
import { CoreFeatureModule } from "@core/frontend-shared";

export default [
	// include base feature info
	CoreFeatureModule.forRoot([
		CoreBaseFeature,
		MessagesBaseFeature,
		DocumentationBaseFeature,
		MailBaseFeature,
		ConsoleBaseFeature,
		AbilitiesBaseFeature,
		MediaBaseFeature,
		CloudinaryBaseFeature,
		FaqBaseFeature,
		MaintenanceBaseFeature,
		NotificationsBaseFeature,
		StatisticsBaseFeature,
		CmsBaseFeature,
		FeedbackBaseFeature,
		MailerBaseFeature,
		UsersBaseFeature,
		AccessibilityBaseFeature,
		AuthStrategyCredentialsBaseFeature,
		TrackingBaseFeature,
		TaskSchedulerBaseFeature,
		UsersPasswordResetQrcodeBaseFeature,
		MembershipBaseFeature,
		PaymentReminderBaseFeature,
		MpfMembershipPluginPaymentBaseFeature,
		MpfContactBaseFeature,
		MpfUsersBaseFeature,
		MpfCoursesBaseFeature,
		MpfDocentsBaseFeature,
		MpfAppBaseFeature,
		MpfOptinUnlockVideoJumpingBaseFeature
	],[
		{token:DevToolProviderToken, value:clientCacheDevToolProvider},
		{token:DevToolProviderToken, value:modelMetadataDevToolDefinition},
		{token:DevToolProviderToken, value:storeInspectorDevToolDefinition},
		{token:MEDIA_ASSET_PROVIDER_TOKEN, value:MediaAssetProviderCloudinaryFrontend},
		{token:ACCESS_SERVICE_PLUGIN_TOKEN, value:AccessUserPluginFrontend},
		{token:MEMBERSHIP_PLUGINS_TOKEN, value:MpfPaymentFrontendMembershipPlugin}
	]),

	// load feature plugins for this platform
	CoreFrontendSharedFeature,
	MessagesFrontendFeature,
	DocumentationFrontendAdminFeature,
	ConsoleFrontendSharedFeature,
	AbilitiesFrontendAdminFeature,
	MediaFrontendAdminFeature,
	CloudinaryFrontendAdminFeature,
	FaqFrontendAdminFeature,
	MaintenanceFrontendAdminFeature,
	NotificationsFrontendAdminFeature,
	StatisticsFrontendAdminFeature,
	CmsFrontendAdminFeature,
	FeedbackAdminFeature,
	MailerFrontendAdminFeature,
	UsersAdminFeature,
	AccessibilityFrontendFeature,
	AuthStrategyCredentialsFrontendFeature,
	AuthStrategyCredentialsFrontendAdminFeature,
	TrackingFrontendAdminFeature,
	TaskSchedulerFrontendAdminFeature,
	MembershipFrontendAdminFeature,
	PaymentReminderFrontendAdminFeature,
	MpfContactFrontendAdminFeature,
	MpfUsersFrontendAdminFeature,
	MpfCoursesAdminFeature,
	MpfDocentsFrontendAdminFeature,
	MpfAppFrontendAdminFeature
] as const;

